import { Language } from './app-header.model';

export const languages: Language[] = [
  {code: 'en', name: 'English', icon: {name: 'flag_en', path: 'assets/icons/flags/en.svg'}},
  {code: 'de', name: 'Deutsch', icon: {name: 'flag_de', path: 'assets/icons/flags/de.svg'}}
];
